interface Props {
  size?: number
  color?: string
  /** Espessura do anel em px. Default escala com size. */
  thickness?: number
}

/** Spinner SVG simples — gira via CSS keyframes. */
export default function Spinner({ size = 18, color = 'currentColor', thickness }: Props) {
  const t = thickness ?? Math.max(2, Math.round(size / 9))
  return (
    <span
      role="status"
      aria-label="Carregando"
      style={{
        display: 'inline-block',
        width: size, height: size,
        border: `${t}px solid rgba(255,255,255,0.15)`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'ct-spin 0.7s linear infinite',
      }}
    >
      <style>{`@keyframes ct-spin { to { transform: rotate(360deg); } }`}</style>
    </span>
  )
}
